import React, { useState } from 'react'
import ReactModal from 'react-modal'
import USD from '../usd'

const RefundPreview = props => {
  const transaction = props.transaction
  if (!transaction) return null
  const creditCard = transaction.source == 'Credit Card'

  const amounts = transaction.receipt.amount
  const tableRows = transaction.items.map(item => {
    return (
      <tr key={item.id} className='included'>
        <td>{item.name}</td>
        <td><USD val={item.netAmount}/></td>
      </tr>
    )
  })
  return (
    <div className='refund-modal__preview'>
      <div className='refund-modal__table'>
        <table>
          <tbody>
            {tableRows}
            <tr className='included'><td>Tax</td><td><USD val={+amounts.tax}/></td></tr>
            <tr className='included'><td>Discount</td><td><USD val={+amounts.discount}/></td></tr>
            <tr className='total'>
              <td>Total</td><td><USD val={+amounts.total}/></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='refund-modal__type-buttons'>
        <button className='btn btn-success' disabled={creditCard} onClick={props.onClickCashRefund}>
          Cash
        </button>
        <button
          className='btn btn-default'
          disabled={!creditCard}
          onClick={props.onClickCashRefund}
        >
          Credit Card
        </button>
      </div>
    </div>
  )
}

const Confirmation = props => {
  const transaction = props.transaction
  if (!transaction) return null

  const amounts = transaction.receipt.amount
  return (
    <div className='refund-modal__confirmation'>
      <div className='refund-modal__confirmation-back'>
        <span className='fa fa-angle-left' onClick={props.onClickCancelConfirm} />
      </div>
      <div className='refund-modal__confirmation-header'><span className='fa fa-check-circle-o'/></div>
      <div className='refund-modal__confirmation-subheader'>Amount to Return</div>
      <div className='refund-modal__confirmation-amount'><USD val={+amounts.total}/></div>
      <div className='refund-modal__confirmation-buttons'>
        <button onClick={props.onConfirmReceipt}>Print Receipt</button>
        <button onClick={props.onConfirm}>Done</button>
      </div>
    </div>
  )
}

export default function RefundModal(props) {
  const [confirmation, setConfirmation] = useState(false)

  const transaction = props.transaction
  const contentClass = `refund-modal__content ${confirmation ? 'shifted' : ''}`

  return (
    <ReactModal contentLabel='Refund' isOpen={!!transaction} onRequestClose={props.onClose}>
      <div className='refund-modal__body'>
        <div className={contentClass}>
          <RefundPreview transaction={transaction} onClickCashRefund={() => setConfirmation(true)} />
          <Confirmation 
            transaction={transaction}
            onConfirm={props.onConfirm}
            onConfirmReceipt={props.onConfirmReceipt}
            onClickCancelConfirm={() => setConfirmation(false)}
          />
        </div>
      </div>
    </ReactModal>
  )
}
